import api from "../services/api";
import { APIS } from "../endpoints";

// Returns true when the filter payload has no user-applied selections.
// Backend treats any non-empty `filters` query param as a filtered query and
// returns an empty result, so we OMIT the param entirely on initial loads
// (default state: empty filters object + default sortBy_v + empty search).
const _isDefaultFilterOptions = (opts) => {
  if (!opts || typeof opts !== "object") return true;
  const filters = opts.filters;
  const hasFilterValues =
    filters &&
    typeof filters === "object" &&
    Object.values(filters).some((v) =>
      Array.isArray(v) ? v.length > 0 : Boolean(v),
    );
  if (hasFilterValues) return false;
  if (opts.search) return false;
  return true;
};

export const getAllExploreData = async (
  limit,
  page_number,
  searchTerm,
  filterOptions = {},
) => {
  const formData = new FormData();
  formData.append("page_number", page_number);
  formData.append("limit", limit);

  if (!_isDefaultFilterOptions(filterOptions)) {
    const cleanedOptions = {
      ...filterOptions,
      filters: Object.fromEntries(
        Object.entries(filterOptions.filters || {}).filter(([, v]) =>
          Array.isArray(v) ? v.length > 0 : Boolean(v),
        ),
      ),
    };
    formData.append("filters", JSON.stringify(cleanedOptions));
  }

  if (searchTerm) {
    formData.append("search", searchTerm);
  }

  if (filterOptions?.sortBy_v) {
    const sortKey = filterOptions.sortBy_v;
    if (sortKey.endsWith("_desc")) {
      formData.append("sort_by", sortKey.slice(0, -5));
      formData.append("sort_order", "desc");
    } else {
      formData.append("sort_by", sortKey);
      formData.append("sort_order", "asc");
    }
  }

  const params = new URLSearchParams(formData);
  const result = await api.get(`${APIS.BASE_URL}${APIS.explore_page}`, {
    params: params,
  });

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};
